
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

 const replaceTextareasForPrint = (container) => {
  const textareas = container.querySelectorAll('textarea');
  textareas.forEach(textarea => {
    const value = textarea.value;

    const clone = document.createElement('div');
    clone.className = 'textarea-print-clone';
    clone.textContent = value;

    const computed = getComputedStyle(textarea);
    const rect = textarea.getBoundingClientRect();

    clone.style.width = `${rect.width}px`;
    clone.style.height = `${Math.max(textarea.scrollHeight, rect.height)}px`;
    clone.style.font = computed.font;
    clone.style.padding = computed.padding;
    clone.style.border = computed.border;
    clone.style.borderRadius = computed.borderRadius;
    clone.style.whiteSpace = 'pre-wrap';
    clone.style.overflowWrap = 'break-word';
    clone.style.boxSizing = 'border-box';
    clone.style.background = computed.background;
    clone.style.color = computed.color;
    clone.style.borderLeftColor = 'rgb(222, 226, 230)';
    clone.style.borderRightColor = 'rgb(222, 226, 230)';
    clone.style.borderTopColor = 'rgb(222, 226, 230)';
    clone.style.borderBottomColor ='rgb(222, 226, 230)';

    // Hide original and mark for restore
    textarea.style.display = 'none';
    textarea.setAttribute('data-_was-hidden-for-print', 'true');

    // Insert clone after textarea
    textarea.parentNode.insertBefore(clone, textarea.nextSibling);
  });
};

 const restoreTextareasAfterPrint = (container) => {
  const textareas = container.querySelectorAll('textarea[data-_was-hidden-for-print]');
  textareas.forEach(textarea => {
    // Unhide and remove the marker
    textarea.style.display = '';
    textarea.removeAttribute('data-_was-hidden-for-print');

    // Remove the inserted clone (if it's still there)
    const clone = textarea.nextSibling;
    if (clone && clone.classList.contains('textarea-print-clone')) {
      clone.remove();
    }
  });
};

export const generatePdfFromElement = async (element) => {
  const originalStyles = {
    width: element.style.width,
    minWidth: element.style.minWidth,
    maxWidth: element.style.maxWidth
  };

  const scale = 1;
  const topMarginPt = 40;
  const overlapPx = 10 * scale;
  const bottomTrim = 10 * scale;

  element.classList.add('generating-pdf');
  element.style.width = '1000px';
  element.style.minWidth = '1000px';
  element.style.maxWidth = '1000px';

  try {
    replaceTextareasForPrint(element);

    const canvas = await html2canvas(element, {
      useCORS: true,
      scale,
      backgroundColor: '#ffffff'
    });

    restoreTextareasAfterPrint(element);

    const pdf = new jsPDF({
      orientation: 'p',
      unit: 'pt',
      format: 'a4',
      compress: true
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const availablePdfHeight = pdfHeight - topMarginPt;

    const canvasWidth = canvas.width;
    const canvasHeight = canvas.height;

    const markers = Array.from(element.querySelectorAll('.page-break'));
    const breakPoints = [0];
    markers.forEach(marker => {
      let next = marker.nextElementSibling;
      while (next && next.offsetHeight === 0) next = next.nextElementSibling;
      const breakY = (next || marker).offsetTop * scale;
      breakPoints.push(breakY);
    });
    breakPoints.push(canvasHeight);

    for (let i = 0; i < breakPoints.length - 1; i++) {
      const startY = i === 0 ? breakPoints[i] : breakPoints[i] - overlapPx;
      const endY = breakPoints[i + 1];
      const sliceHeight = endY - startY - bottomTrim;

      const pageCanvas = document.createElement('canvas');
      pageCanvas.width = canvasWidth;
      pageCanvas.height = sliceHeight;
      const ctx = pageCanvas.getContext('2d');

      ctx.drawImage(
        canvas,
        0, startY,
        canvasWidth, sliceHeight,
        0, 0,
        canvasWidth, sliceHeight
      );

      const imgData = pageCanvas.toDataURL('image/jpeg', 0.8);
      const imgHeight = (sliceHeight * pdfWidth) / canvasWidth;
      const scaledImgHeight = Math.min(imgHeight, availablePdfHeight);

      if (!isFinite(scaledImgHeight) || scaledImgHeight <= 0) continue;

      if (i > 0) pdf.addPage();

      pdf.addImage(
        imgData,
        'JPEG',
        0,
        i === 0 ? 0 : topMarginPt,
        pdfWidth,
        scaledImgHeight
      );
    }

    return { pdf, restore: () => {
      element.style.width = originalStyles.width;
      element.style.minWidth = originalStyles.minWidth;
      element.style.maxWidth = originalStyles.maxWidth;
      element.classList.remove('generating-pdf');
    }};
  } catch (err) {
    element.style.width = originalStyles.width;
    element.style.minWidth = originalStyles.minWidth;
    element.style.maxWidth = originalStyles.maxWidth;
    element.classList.remove('generating-pdf');
    throw err;
  }
};

export const downloadPdf = async (pdf, formName) => {
    console.log("Standard download");   
    pdf.save(`${formName}.pdf`);    
}

export const getPdfBlob = async (pdf, restore) => {
  try {
    return pdf.output('blob');
  } finally {
    restore();
  }
};